import { Alert, Button, Card, Col, Container, Row } from 'react-bootstrap';
import React, { useState } from 'react';

import CloseButton from './Styled/CloseButton';
import DeleteAccountModal from './Modal/DeleteAccount/DeleteAccountModal';
import Icon from './Icon';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import currentUserPropTypes from '../propTypes/currentUserPropTypes';
import { primary } from '../theme/colors';
import styled from 'styled-components';

const StyledCard = styled(Card)`
  border-color: #afb6b9;
`;

const DeleteAccountBlock = ({
  currentUser,
  setIsDeleting,
  deleteError,
  setDeleteError,
}) => {
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
  return (
    <>
      <DeleteAccountModal
        show={showDeleteAccountModal}
        onHide={() => setShowDeleteAccountModal(false)}
        currentUser={currentUser}
        setIsDeleting={setIsDeleting}
        deleteError={deleteError}
        setDeleteError={setDeleteError}
      />
      <Container id="delete-account">
        <Row>
          <Col className="mb-1" lg={8}>
            <Icon colour={primary} icon="delete-account" className="mb-2" />
            <h2>Delete Account</h2>
          </Col>
        </Row>
        <Row>
          <Col className="mb-3" lg={8}>
            <StyledCard>
              <Card.Body>
                <ReactMarkdown>
                  Permanently delete your Loop account and all of your data.
                </ReactMarkdown>
                {deleteError && (
                  <Alert
                    variant="danger"
                    onClose={() => setDeleteError(undefined)}>
                    There was a problem removing your account - {deleteError}
                    <CloseButton onClick={() => setDeleteError(undefined)} />
                  </Alert>
                )}
                <Button
                  variant="link"
                  className="p-0 m-0"
                  onClick={() => {
                    setDeleteError(undefined);
                    setShowDeleteAccountModal(true);
                  }}>
                  Delete account
                </Button>
              </Card.Body>
            </StyledCard>
          </Col>
        </Row>
      </Container>
    </>
  );
};

DeleteAccountBlock.propTypes = {
  ...currentUserPropTypes,
  setIsDeleting: PropTypes.func,
};

export default DeleteAccountBlock;
